import { ILossPreventionConfig } from '../useLossPreventionConfig'

export const bibibopConfig: ILossPreventionConfig = {
  summary: {
    isVisible: true,
  },
  kpiSettings: [
    { category: 'basic', key: 'totalComps', title: 'Total Discounts' },
    { category: 'basic', key: 'compsPercent', title: 'Discounts %' },
    {
      category: 'basic',
      key: 'cashOverOrShort',
      title: 'Cash +/-',
      fromMetric: 'cash_over_or_short',
    },
    {
      category: 'custom',
      type: 'Voids',
      title: 'Voids',
      key: 'amount',
    },
  ],
  cashHandlingTable: {
    display: false,
    columns: [],
  },
  voidsAndDeletesTable: {
    display: false,
    columns: [],
  },
  discountByEmployeeTable: {
    display: false,
  },
  opsCompsBreakdownTable: {
    display: true,
  },
}
